export default {
    empty: 'No team members have been revoked.',
    endDate: 'End Date',
    name: 'Name',
    reactivate: 'Reactivate',
    startDate: 'Start Date',
    subtitle:
        'The following team members no longer have access to this company.',
    title: 'Revoked Team Members',
};
